module.exports = __webpack_public_path__ + "img/icon-Social5.4ebf74bc.png";